<template>
    <div :style="style">
        <Wp_img_swipe
                      :title="title"
                      :auto-play="auto_play"
                      :round="round"
                      :list="list"
                      @clickImage="clickActivesItem"
        >
        </Wp_img_swipe>

<!--        <van-popup v-model="showLoading">-->
<!--            <van-loading type="spinner" color="#1989fa" vertical-->
<!--                         style="padding: 30px;">-->
<!--                <div slot="default" style="text-align: center" >加载中...</div>-->
<!--            </van-loading>-->
<!--        </van-popup>-->
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Toast } from 'vant';
    Vue.use(Toast);

    import Wp_img_swipe from "../custom/Wp_img_swipe";
    export default {
        name: "Wp_home_actives_model",
        components: {Wp_img_swipe},

        props:{
            params:{type: Object}
        },

        data(){
            return{
                image_height: 0,
                title: "",
                round: false,
                auto_play: 5000,
                list: [],
                style: "",

                showLoading: false,
            }
        },

        created(){
            this.initBannerDatas();
        },

        methods:{

            initBannerDatas(){
                if(this.params){
                    if(this.params.title){
                        this.title = this.params.title;
                    }
                    if(this.params.round){
                        this.round = this.params.round;
                    }
                    if(this.params.auto_play){
                        this.auto_play = this.params.auto_play;
                    }
                    if(this.params.list){
                        this.list = this.params.list;
                    }
                    if(this.params.style){
                        this.style = this.params.style;
                    }

                }
            },

            clickActivesItem(item){
                // this.$common.homeModelClickTo(item, this.$router);
                this.$clickHomeModelTo(item);
            },

        }
    }
</script>

<style scoped>

</style>